class o extends Error {
  constructor(e, s, t, r) {
    super(e, r), this.code = s, this.details = t, this.name = "HostRequestError";
  }
  code;
  details;
  static fromCause(e, s, t, r) {
    return new o(s, t, r, { cause: e });
  }
}
export {
  o as HostRequestError
};
//# sourceMappingURL=host-errors.js.map
